// This hook is an upgrade to the native useCallback of React
// The goal is to add a flag to the function object that ensure that differentiate between simple function
// To a function made with useCallback

import React, { useCallback } from 'react';

// In this case we would accept any as the args are free to choose // Ron R.
// eslint-disable-next-line  @typescript-eslint/no-explicit-any
type AnyFunction = (...args: any) => unknown;

const useFlaggedCallback = <T extends AnyFunction>(callback: T, dependencies: React.DependencyList): FlaggedCallBack<T> => {
  const flaggedCallback: FlaggedCallBack<T> = useCallback(callback, dependencies) as FlaggedCallBack<T>;

  flaggedCallback.isFlaggedCallback = true;

  return flaggedCallback;
};

export type FlaggedCallBack<T extends AnyFunction> = {
  isFlaggedCallback: true;
} & T;

export default useFlaggedCallback;
